import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RefundPaymentDialogComponent } from './refund-payment-dialog.component';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';

@NgModule({
  declarations: [RefundPaymentDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    WsUiModule
  ],
  exports: [RefundPaymentDialogComponent]
})
export class RefundPaymentDialogModule { }
